// extracted by mini-css-extract-plugin
export default {"switch":"f94f78123560372a95f5","thumb":"e00ce33c90d86bf989b9"};